import React, { useCallback, useRef, useState } from 'react';
import axios from '../../sagas/axios';
import ModalAlert from '../../components/modal/modal_alert';
import ModalLoader from '../../../modal/modal_loader';
import compressImage from '../../../../lib/image_compressor';

const Edit = ({ placeCategory, isApp, imageDataMedium }) => {
  const [urlKey, setUrlKey] = useState(placeCategory.url_key || '');
  const [name, setName] = useState(placeCategory.name || '');
  const [description, setDescription] = useState(
    placeCategory.description || ''
  );
  const [sortOrderScore, setSortOrderScore] = useState(
    placeCategory.sort_order_score || 0
  );
  const [isDeleted, setIsDeleted] = useState(placeCategory.is_deleted || false);
  const [image, setImage] = useState(imageDataMedium || '');

  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onChangeImageData = useCallback(
    async (imageFile) => {
      const compressedFile = await compressImage(imageFile);
      let formData = new FormData();
      formData.append('file', compressedFile);
      axios
        .patch(
          `/api/place_categories/${placeCategory.id}/upload_image`,
          formData
        )
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setImage(response.data.image_data_medium);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        url_key: urlKey,
        name,
        description,
        sort_order_score: sortOrderScore,
        is_deleted: isDeleted,
      });
      axios
        .post(`/api/place_categories/${placeCategory.id}/update`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      placeCategory,
      urlKey,
      description,
      sortOrderScore,
      isDeleted,
    ]
  );

  const toPlacesPage = useCallback(() => {
    window && (window.location.href = '/admin/place_categories');
  });

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="bg-gray h-100 pt-3 min-vh-100"
      >
        <div className="container col-md-8 col-lg-6 p-3_5 d-flex justify-content-around">
          <label htmlFor="image">
            <a
              className={`card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block`}
            >
              {image ? (
                <img
                  src={image}
                  alt="image"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              ) : (
                <img
                  src="/assets2019/img/icon_camera.svg"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              )}
              <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => {
                  onChangeImageData(e.target.files[0]);
                }}
                id="image"
                style={{ display: 'none' }}
              />
            </a>
          </label>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            場所カテゴリ名
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            URLキー
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={urlKey}
              onChange={(e) => setUrlKey(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            ディスクリプション
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            表示順（大きい方が優先順位高）
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="number"
              className="p-0 w-100 textarea--eventreport"
              value={sortOrderScore}
              onChange={(e) => setSortOrderScore(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開/非公開
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-deleted"
                className=""
                checked={!isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-deleted"
                className="ml-3"
                checked={isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(true)}
              />
              非表示
            </label>
          </div>
        </div>
      </main>
      <div className="fixed-bottom">
        <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
          <div
            className="container d-flex justify-content-around"
            style={{ marginBottom: isApp ? '24px' : '' }}
          >
            <button
              type="button"
              className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                isApp == false ? 'mb-2' : ''
              }`}
              onClick={(e) => onSubmit(e)}
            >
              作成/更新する
            </button>
          </div>
        </div>
      </div>
      <ModalAlert
        ref={successRef}
        name="コース作成完了"
        content="コース作成/更新に成功しました。"
        approveFunc={toPlacesPage}
      />
      <ModalAlert
        ref={errorRef}
        name="コース作成失敗"
        content="コース作成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
